<template>
  <div>
    <main>
      <router-view/>
      <template v-if="this.selected_circular_issue.id === 11 && hasRagAccess">
        <button class="chat-toggle-btn" @click="toggleChat">
          <template v-if="showChat">
            <font-awesome-icon icon="fas fa-times"></font-awesome-icon>
          </template>
          <template v-else>
            <font-awesome-icon icon="fas fa-comment"></font-awesome-icon>
          </template>
        </button>
        <button v-if="showChat" class="fullscreen-btn btn btn-primary"   @click="toggleFullScreen">
          <font-awesome-icon :icon="isFullscreen ? 'fas fa-compress' : 'fas fa-expand'" class="text-white"></font-awesome-icon>
        </button>
      </template>
      <!-- Chat Box -->
      <div class="chat-container" v-if="showChat">
        <!-- Tab Buttons -->
        <div class="selector-toggle">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <button class="toggle-btn"  :disabled="isAiTyping" :class="{ active: selected === 'ai'}" @click="selected='ai'">
              <font-awesome-icon icon="fas fa-brain" class="pr-1" :class="[this.selected !== 'ai' ? 'text-secondary': 'text-white']"></font-awesome-icon> AI Q&A
            </button>
            <button class="toggle-btn" :disabled="isAiTyping" :class="{ active: selected === 'search'}" @click="selected='search'">
              <font-awesome-icon icon="fas fa-search" class="pr-1" :class="[this.selected !== 'search' ? 'text-secondary': 'text-white']"></font-awesome-icon> Elite Deep Search
            </button>
          </div>

          <div class="sub-menus text-right">
            <button @click="clearChat" class="btn btn-danger btn-xs" style="background: #e50c22 !important; padding: .45rem !important;">
              <font-awesome-icon icon="fas fa-trash"></font-awesome-icon>
              <span class="pl-2">Clear</span>
            </button>
          </div>
        </div>


        <!-- Transitioned Chat Box -->
        <transition name="fade-tab" mode="out-in">
          <div :key="selected" :class="['chat-box',isFullscreen ? 'fullscreen' : '']">
            <template v-if="selected === 'ai'">
              <div
                  v-for="(msg, index) in ragMessage"
                  :key="index"
                  :class="['message', msg.sender === 'bot' ? 'bot' : 'user']"
              >
                <div v-if="msg.sender === 'bot' && msg.typing" :ref="'typing-' + index"></div>
                <div v-else v-html="msg.text"></div>
              </div>
            </template>
            <template v-else>
              <div
                  v-for="(msg, index) in deepSearchMessage"
                  :key="index"
                  :class="['message', msg.sender === 'bot' ? 'bot' : 'user']"
              >
                <div v-if="msg.sender === 'bot' && msg.typing" :ref="'typing-' + index"></div>
                <template  v-else >
                  <div v-html="msg.text"></div>
                </template>

              </div>
            </template>
          </div>
        </transition>

        <!-- Chat Input -->
        <div class="chat-input">
           <textarea
               v-model="newMessage"
               class="form-control"
               rows="2"
               placeholder="Type your message..."
               @keydown.enter.prevent="handleKeyPress"
           ></textarea>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import {marked} from "marked";
import {mapGetters} from "vuex";
import {UacMixins} from "@/mixins/uac.mixins";

const renderer = new marked.Renderer();
renderer.heading = function (text, level, raw) {
  const shortId = raw
      .toLowerCase()
      .replace(/[^\w]+/g, '-')  // Replace non-word characters with dash
      .replace(/^-+|-+$/g, '')  // Trim leading/trailing dashes
      .substring(0, 50);        // Limit length
  return `<h${level} id="${shortId}">${text}</h${level}>`;
};

marked.setOptions({
  renderer
});

export default {
  name: 'Content',
  data() {
    return {
      newMessage: '',
      isTyping: false,
      isFullscreen: false,
      showChat: false,
      selected: 'ai',
      input: '',
      ragMessage:[],
      deepSearchMessage:[],
      isAiTyping:false,
    }
  },
  mixins:[UacMixins],
  methods: {
    handleKeyPress(e) {
      if (e.ctrlKey) {
        const textarea = e.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        this.newMessage = this.newMessage.slice(0, start) + "\n" + this.newMessage.slice(end);
        this.$nextTick(() => {
          textarea.selectionStart = textarea.selectionEnd = start + 1;
        });
      } else {
        this.sendMessage(this.selected);
      }
    },
    async sendMessage(type) {
      const text = this.newMessage.trim();
      this.newMessage='';
      if(text){
        const parameter = {
          sender: 'user',
          text: text,
          typing: false
        }

        if(type === 'ai') {
          this.ragMessage.push(parameter)
        }
        else {
          this.deepSearchMessage.push(parameter)
        }

        const response = await RagService.fetchRagResponse(text,this.selected)

        if(response)
          this.isAiTyping=true;
          if (this.selected === 'ai') {
            let html = marked(response.answer)

            this.ragMessage.push({
              sender: 'bot',
              text: '',
              rawMarkdown: response.answer ?? '',
              typing: true
            })

            html = RagService.generateAiResponse(html,response.sources)
            this.$nextTick(async () => {
              const index = this.ragMessage.length - 1;
              const el = this.$refs['typing-' + index]?.[0];
              if(el){
                await this.typeMarkdown(el, response.answer);
                this.$set(this.ragMessage[index], 'text', html);
                this.$set(this.ragMessage[index], 'typing', false);
                this.scrollToBottom();
              }
              this.isAiTyping=false;
            })

          }
          else {
            let html =`<p>${response.answer ?? '' }</p>`;
            if(response.results.length > 0) {
              html = RagService.generateAiResponse(html,response.results)
            }
            this.deepSearchMessage .push({
              sender: 'bot',
              text: html,
              rawMarkdown: '',
              typing: false
            })
            this.isAiTyping=false
          }
      }
    },

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    async typeCharacters(el, text, speed = 5) {
      for (let i = 0; i < text.length; i++) {
        el.innerHTML += text[i];
        await this.delay(speed);
        this.scrollToBottom();
      }
    },
    async typeMarkdown(el, markdown) {
      const html = marked(markdown);
      const temp = document.createElement('div');
      temp.innerHTML = html;
      const nodes = Array.from(temp.childNodes);

      for (const node of nodes) {
        if (node.nodeType === Node.TEXT_NODE) {
          // Handle plain text nodes
          const textNode = document.createTextNode('');
          el.appendChild(textNode);
          await this.typeCharacters(textNode, node.textContent);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const newNode = document.createElement(node.nodeName);
          el.appendChild(newNode);

          if (node.nodeName === 'UL' || node.nodeName === 'OL') {
            for (const item of node.children) {
              const li = document.createElement('li');
              newNode.appendChild(li);
              await this.typeCharacters(li, item.textContent);
            }
          } else {
            await this.typeCharacters(newNode, node.textContent);
          }
        }
      }
    },
    toggleChat() {
      this.showChat = !this.showChat;
      if(this.showChat === false) {
        this.isFullscreen=false;
      }
    },
    toggleFullScreen() {
      this.isFullscreen = !this.isFullscreen;
      const container = this.$el.querySelector('.chat-container');
      if (this.isFullscreen) {
        container.classList.add('fullscreen');
      } else {
        container.classList.remove('fullscreen');
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const box = this.$el.querySelector('.chat-box');
        if (box) {
          box.scrollTop = box.scrollHeight;
        }
      });
    },
    clearChat(){
      if(this.selected==='ai'){
        this.ragMessage = [{
          sender: 'bot',
          text: 'Chat cleared. How can I help you today?',
          rawMarkdown: '',
          typing: false
        }]
      }
      else{
        this.deepSearchMessage = [
          {
            sender: 'bot',
            text: 'Chat cleared. How can I help you today?',
            rawMarkdown: '',
            typing: false
          }
        ]
      }
    }
  } ,
  computed:{
    ...mapGetters([
        'selected_circular_issue'
    ])
  }
};
</script>

<style scoped>
/* Floating button toggler */
.chat-toggle-btn {
  position: fixed;
  bottom: 5px;
  right: 20px;
  background: #e50c22;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  font-size: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  z-index: 20;
  transition: background 0.3s ease;
}

.chat-toggle-btn:hover {
  background: #c80a1d;
}

/* Chat Container */
.chat-container {
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 400px;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  animation: slideUp 0.3s ease;
  z-index: 10;
  display: flex;
  flex-direction: column;
  max-height: 460px;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.close-btn:hover {
  color: #333;
}

/* Selector tab bar */
.selector-toggle {
  display: flex;
  background: #f7f9fc;
  padding: 10px;
  border-bottom: 1px solid #e2e6ea;
  flex-direction: column;
}

.toggle-btn {
  flex: 1;
  font-size: 12px;
  font-weight: 500;
  padding: 6px 8px;
  border: none;
  background: transparent;
  border-radius: 8px;
  transition: all 0.3s ease;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-btn i {
  margin-right: 6px;
}

.toggle-btn.active {
  background-color: #e50c22;
  color: white;
  font-weight: bold;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

/* Scrollable Message Area */
.chat-box {
  display: flex;
  flex-direction: column;
  gap: 8px;                /* spacing between messages */
  padding: 12px;
  height: 350px;
  overflow-y: auto;
}

.chat-box.fullscreen{
  height: 80% !important;
}

.chat-box.fullscreen .message {
  max-width: 65% !important;
}

.message{
  max-width: 80%;
  padding: 10px 14px;
  border-radius: 15px;
  word-wrap: break-word;
  font-size: 13px;
  line-height: normal;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
  margin-bottom: 10px;
  text-align: left;
}

.message.bot {
  align-self: flex-start !important;
  background-color: #f1f3f5;
  color: #333;
}

.message.user {
  align-self: flex-end !important;
  background-color: #007bff;
  color: white;
}
::v-deep .message.bot p{
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
}

.message.bot.typing {
  display: flex;
  align-items: center;
  padding: 14px 18px;
}

.message.bot.typing span {
  height: 8px;
  width: 8px;
  background-color: #90949c;
  border-radius: 50%;
  margin: 0 2px;

  animation: typingDots 1.4s infinite ease-in-out both;
}

.message.bot.typing span:nth-child(1) {
  animation-delay: 0s;
}
.message.bot.typing span:nth-child(2) {
  animation-delay: 0.2s;
}
.message.bot.typing span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes typingDots {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1.0);
  }
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

/* Chat input */
.chat-input {
  border-top: 1px solid #e2e6ea;
  padding: 10px;
  background: #fafbfc;
}

.chat-input input {
  width: 100%;
  border: 1px solid #ccc;
  padding: 8px 14px;
  border-radius: 18px;
  font-size: 13px;
  outline: none;
  transition: border-color 0.2s;
}

.chat-input input:focus {
  border-color: #007bff;
}

/* Vue transition tabs */
.fade-tab-enter-active, .fade-tab-leave-active {
  transition: opacity 0.3s ease;
}

.fade-tab-enter, .fade-tab-leave-to {
  opacity: 0;
}

.fullscreen-btn {
  position: fixed;
  bottom: 5px;
  right: 80px;
  background: #e50c22;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  font-size: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  z-index: 20;
  transition: background 0.3s ease;
}

.fullscreen-btn:hover {
  color: #333;
}

/* Fullscreen styles */
.chat-container.fullscreen {
  top: 20px;
  bottom: 20px;
  left: 20px;
  right: 20px;
  width: auto !important;
  height: auto !important;
  max-height: none;
  max-width: none;
  border-radius: 12px;
}

.toggle-btn:disabled{
  cursor: not-allowed;
}
</style>
